import {applyFilters} from '@explorer/actions/item-filters';
import {setOverlayOn} from '@explorer/actions/map';
import {
  defineGeometry,
  setDateRanges,
  setSearchPageNumber,
} from '@explorer/actions/search';
import {OVERLAYS} from '@explorer/constants/map.js';

export const buildSearchActions = storedState => {
  const actions = [];
  if (storedState.search) {
    if (storedState.search.geometry) {
      actions.push(
        defineGeometry({
          geometry: {...storedState.search.geometry},
          isGeometryTooComplex: storedState.search.isGeometryTooComplex,
          zoomTo: false,
          fromHash: true,
        })
      );
    }
    if (storedState.search.showCenterMarker) {
      actions.push(
        setOverlayOn({
          name: OVERLAYS.CENTER_MARKER,
          on: storedState.search.showCenterMarker,
        })
      );
    }
    if (storedState.search.dateRanges) {
      actions.push(setDateRanges(storedState.search.dateRanges));
    }

    if (storedState.filters) {
      // check for ground control and image quality which
      //  use an array with only one element
      //  but is stored as a string for easier validation.
      const singletons = ['ground_control', 'quality_category'];
      singletons.forEach(key => {
        if (storedState.filters[key]) {
          if (!Array.isArray(storedState.filters[key])) {
            storedState.filters[key] = [storedState.filters[key]];
          }
        }
      });
      actions.push(applyFilters(storedState.filters));
    }
    if (storedState.search.page >= 0) {
      actions.push(setSearchPageNumber(storedState.search.page));
    }
  }

  return actions;
};
